import { useForm } from 'react-hook-form';

import { TParentChannelForm } from '../types';

export const DEFAULT_VALUES: Partial<TParentChannelForm> = {
  name: '',
  short_name: '',
  av_code: '',
  language_id: '',
  country_code: '',
  logo: '',
  region_code: null,
  subregion_code: null,
  provider: null,
  parameters: {
    enrichments: {
      advertising: false,
      logos: false,
      ocr: false,
      peoples: false,
      stt: false,
    },
  },
  backup_channel_id: '',
};

export function useParentBroadcastersDrawerFormState() {
  const form = useForm<TParentChannelForm>({
    mode: 'all',
    defaultValues: DEFAULT_VALUES,
  });

  return { form };
}
